import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";

// Root sin layout — cada subtree decide su shell. Las rutas públicas
// (login / accept-invite / reset-password) renderean sin AppShell.
// `/_app/*` envuelve con AppShell + auth-guard.
export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => <Outlet />,
});
